/* @flow */
import React from 'react';
import Button from 'components/Button.jsx';
import ConfirmDialog from 'components/ConfirmDialog.jsx';
import CurrentUser from 'auth/CurrentUser';
import Divider from 'components/Divider.jsx';
import FeatureStore from 'stores/FeatureStore';
import Link from 'components/Link.jsx';
import LinkConstants from 'constants/LinkConstants';
import ModalTrigger from 'components/ModalTrigger.jsx';
import UserActions from 'user/UserActions';
import UserEmailsForm from './UserEmailsForm.jsx';
import UserPasswordForm from './UserPasswordForm.jsx';
import UserPersonalInfoForm from './UserPersonalInfoForm.jsx';
import UserSignatureForm from './UserSignatureForm.jsx';

class AccountSettingsView extends React.Component {
  static onEnter(nextState, replaceWith) {
    if (!FeatureStore.hasFeature('web.new_account')) {
      replaceWith('/settings');
    }
  }

  deleteAccount() {
    window.location = LinkConstants.MARKETING;
  }

  renderConfirmModal() {
    const subtext = CurrentUser.getUser().canCreateGroups() ?
    'You will no longer have access to your classes or participants. ' +
    'This action can’t be undone.' :
    'You will no longer have access to your classes. This action can’t be undone.';

    return (
      <ConfirmDialog
        eventScreenName="AccountSettingsView"
        actionButtonText="Delete"
        cancelButtonText="Cancel"
        size="xsmall"
        glyph="trash"
        glyphColor="lava"
        onConfirm={this.deleteAccount}
        preConfirmPromise={UserActions.delete}
        title="Are you sure you want to delete your account?"
        subtext={subtext}
      />
    );
  }

  renderDeleteAccountForm() {
    return (
      <div>
        <ModalTrigger modal={this.renderConfirmModal()}>
          <Button
            className="UserSettingsView-deleteAccountBtn"
            size="xsmall"
            level="secondary"
            color="lava"
            eventElementName="UserSettingsView-deleteAccountBtn">
            Delete account
          </Button>
        </ModalTrigger>
      </div>
    );
  }

  renderTermsAndPrivacyLink() {
    return (
      <div>
        <Link
          href={LinkConstants.TERMS_OF_SERVICE}
          target="_blank"
          color="thunder">
          Terms & Privacy
        </Link>
      </div>
    );
  }

  render() {
    return (
      <div>
        {
          CurrentUser.getUser().isTeacher() && (
            <div>
              <UserSignatureForm />
              <Divider />
            </div>
          )
        }
        <UserPersonalInfoForm />
        <Divider />
        <UserEmailsForm />
        <Divider />
        <UserPasswordForm />
        <Divider />
        {this.renderDeleteAccountForm()}
        {this.renderTermsAndPrivacyLink()}
      </div>
    );
  }
}

export default AccountSettingsView;



// WEBPACK FOOTER //
// ./src/settings/components/AccountSettingsView.jsx